import React from 'react'

export interface IFormErrorProps {
    children?: React.ReactNode
    /** Id para o `aria-describedby` do campo. */
    id?: string
}

/** Mensagem de erro de um campo (texto pequeno em rosa, com o espaço de cima mesmo sem mensagem). */
const FormError: React.FC<IFormErrorProps> = ({ children, id }) => {
    return (
        <div className="mt-1" id={id}>
            {children && <p className="text-xs text-jolly-rose">{children}</p>}
        </div>
    )
}

export default FormError
